import React from 'react';
import { Callout, List, P, Path, Steps, Sub, Table, UI } from '../ui';

export const Calendar: React.FC = () => (
  <>
    <P>
      <b>내 일정·부서 일정·회사 일정</b>을 한 캘린더에서 봅니다. PC에서는 왼쪽 탭 바의 <UI>캘린더</UI>, 휴대폰에서는
      화면 아래 <UI>캘린더</UI> 탭으로 엽니다. 홈 화면의 <b>일정</b> 카드에서도 이번 달과 오늘 일정을 바로 볼 수
      있습니다.
    </P>

    <Sub>일정 종류</Sub>
    <Table
      head={['종류', '누가 보나', '누가 등록·수정하나']}
      rows={[
        ['내 일정 (파랑)', '나와 참석자로 지정한 동료', '나'],
        ['부서 일정 (초록)', '같은 부서 사람 모두', '부서의 팀장 (인트라넷 팀장 표시가 있는 사람)'],
        ['회사 일정 (보라)', '같은 계열사 직원 모두', '관리자 · 회사 일정 담당자'],
      ]}
    />
    <P>
      인트라넷 <b>부서별일정</b>에 등록된 일정도 부서 일정에 함께 보입니다(점선 테두리와 &lsquo;인트라넷&rsquo; 표시).
      이 일정은 보기만 할 수 있고, 수정·삭제는 인트라넷에서 합니다. 공휴일은 날짜 옆에 이름이 표시됩니다.
    </P>
    <P>
      캘린더 위쪽의 <UI>내 일정</UI>·<UI>부서</UI>·<UI>회사</UI> 버튼으로 보고 싶은 종류만 골라 볼 수 있습니다.
      고른 값은 홈의 일정 카드에도 똑같이 적용됩니다.
    </P>

    <Sub>일정 등록하기</Sub>
    <Steps>
      <>
        캘린더 오른쪽 위 <UI>일정 추가</UI>(휴대폰은 <UI>+</UI>)를 누릅니다. PC에서는 달력의 빈 날짜를 두 번
        클릭해도 그 날짜로 새 일정이 열립니다.
      </>
      <>
        제목과 날짜·시간을 입력합니다. 하루 종일 일정이면 <UI>종일</UI>을 켭니다. 시작 시간을 바꾸면 끝 시간도 같은
        길이만큼 따라 움직입니다.
      </>
      <>
        필요하면 <b>반복</b>·<b>알림</b>·<b>장소</b>·<b>참석자</b>·<b>설명</b>을 채우고 <UI>저장</UI>을 누릅니다.
      </>
    </Steps>
    <Callout tone="info">
      <p>
        팀장이면 <UI>종류</UI>에서 <UI>부서 일정</UI>을, 관리자나 회사 일정 담당자면 <UI>회사 일정</UI>을 고를 수
        있습니다. 등록 권한이 없는 종류는 선택지에 나타나지 않습니다.
      </p>
      <p>
        회사 일정 담당자는 Super Admin이 관리자 콘솔의 <UI>회사 일정 권한</UI>에서 지정하며, 자기 계열사의 회사 일정을
        등록·수정·삭제할 수 있습니다. 지정되면 다시 로그인하지 않아도 바로 선택지가 생깁니다.
      </p>
      <p>일정을 저장하면 내가 쓰는 다른 기기와 함께 보는 동료의 캘린더에도 바로 반영됩니다.</p>
    </Callout>

    <Sub>반복 일정</Sub>
    <P>
      <UI>반복</UI>에서 <b>매일 · 매주 · 매월 · 매년</b> 중 하나를 고르고, 필요하면 <UI>반복 종료일</UI>을 정합니다.
      종료일을 비워 두면 계속 반복합니다. 매월 31일처럼 그 날짜가 없는 달은 건너뜁니다.
    </P>
    <List>
      <>반복 일정을 수정하면 모든 회차가 함께 바뀝니다.</>
      <>
        삭제할 때는 <UI>이 일정만</UI> · <UI>이 일정과 이후 일정 모두</UI> · <UI>모든 일정</UI> 중에서 고릅니다.
      </>
    </List>

    <Sub>일정 알림</Sub>
    <P>
      <UI>알림</UI>에서 <b>시작 시간 · 10분 전 · 30분 전 · 1시간 전 · 하루 전</b>(종일 일정은 <b>당일 오전 9시 · 전날
      오전 9시</b>)을 고르면, 그 시각에 알림함 <UI>일정</UI> 탭과 PC 토스트·휴대폰 알림으로 알려 드립니다. 알림을
      누르면 캘린더의 그 날짜와 일정이 열립니다.
    </P>
    <List>
      <>내 일정의 알림은 나와 참석자(불참으로 응답한 사람 제외)에게 갑니다.</>
      <>부서 일정은 팀장이 알림을 켰을 때만 부서원 모두에게 갑니다.</>
      <>회사 일정은 알림을 보내지 않습니다. 캘린더와 홈의 일정 카드에서 확인하세요.</>
      <>서버 점검 등으로 알림 시각을 15분 넘게 지나치면 늦은 알림은 보내지 않습니다.</>
    </List>

    <Sub>참석자 지정과 초대 응답</Sub>
    <P>
      내 일정의 <UI>참석자</UI> 칸에서 같은 회사 동료를 이름이나 부서로 찾아 넣습니다. 참석자에게는 초대 알림이 가고,
      그 사람의 캘린더에도 일정이 보입니다(응답 전에는 &lsquo;초대 · 응답 전&rsquo;으로 흐리게 표시).
    </P>
    <List>
      <>
        초대받은 일정을 열면 아래쪽 <UI>참석</UI>·<UI>불참</UI>으로 응답합니다. 응답하면 창이 닫히고, 누른 버튼을
        한 번 더 누르면 응답이 지워집니다. <UI>불참</UI>으로 응답하면 내 캘린더에서 사라지고 알림도 오지 않습니다.
      </>
      <>일정을 열면 참석자가 <UI>참석</UI>·<UI>응답 전</UI>·<UI>불참</UI>으로 나뉘어 보이고, 괄호 안 숫자가 인원입니다.</>
      <>일정 시간이 바뀌거나 일정이 취소되면 참석자에게 알림이 갑니다.</>
      <>참석자는 일정을 수정할 수 없습니다. 수정은 등록한 사람만 합니다.</>
    </List>

    <Sub>대화방에 일정 공유하기</Sub>
    <Steps>
      <>
        일정을 열고 <UI>대화방에 공유</UI>를 눌러 보낼 대화방을 고릅니다(한 번에 10곳까지).
      </>
      <>대화방에는 일정 카드가 올라가고, 카드를 누르면 일정 내용을 볼 수 있습니다.</>
    </Steps>
    <List>
      <>
        대화 중에 바로 만들 수도 있습니다. 메시지를 우클릭(휴대폰은 길게 누르기)해 <UI>일정 만들기</UI>를 고르면
        메시지 내용이 제목·설명에 채워지고, 입력창 왼쪽 <Path items={['첨부 버튼', '일정 공유']} /> 를 누르면 빈
        일정이 열립니다. 두 경우 모두 대화방 사람들이 참석자로 들어가고 <UI>대화방에 공유</UI>가 켜진 채
        시작합니다.
      </>
      <>
        공유한 일정은 그 대화방 사람이면 누구나 볼 수 있습니다(보기만 가능). 공유 메시지를 지우면 카드로 보던
        사람도 더 이상 볼 수 없습니다.
      </>
      <>
        카드는 늘 일정의 지금 내용을 보여 줍니다(바뀐 내용은 대화방을 다시 열 때 반영). 일정이 삭제되면 카드가 바로
        &lsquo;삭제된 일정&rsquo;으로 바뀝니다.
      </>
    </List>
  </>
);
